export default __webpack_public_path__ + "static/media/Flag_of_Castile_and_Leon.svg.8783d5f4.png";